<template>
  <div class="model-info-box">
    <img class="head-img" :src="modelInfo.head">
    <h5>{{ modelInfo.name }}</h5>
    <p>身高：{{ modelInfo.height }}cm 三围：{{ modelInfo.measurements }}</p>
    <p>{{ modelInfo.labels }}</p>
  </div>
</template>
<script>
  export default {
    props: {
      info: {
        type: Object,
        required: true
      },
      labels: {
        type: Array,
        // required: true,
        default: []
      }
    },
    computed: {
      modelInfo () {
        const measurements = `${ this.info.bust || '暂无' }/${ this.info.waist || '暂无' }/${ this.info.hip || '暂无' }`;
        let labels = [];
        if (this.labels) {
          this.labels.forEach(item => {
            labels.push(item.chinese);
          });
        }

        return {
          head: this.info.headPortrait,
          name: this.info.webName || '暂无',
          height: this.info.height || '暂无',
          measurements,
          labels: labels.length ? labels.join(', ') : '暂无'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
 .model-info-box {
   margin-bottom: px2rem(20px);
   padding: px2rem(10px) 0;
   text-align: center;
   background-color: #f2f2f2;
   .head-img {
     margin: 0 auto;
     width: px2rem(120px);
     border-radius: px2rem(60px);
   }
   h5 {
     font-size: px2rem(16px);
     line-height: px2rem(24px);
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/ModelInfo.vue